import { formatIncome } from 'lib/Formatting';
import { isFalsy } from 'lib/Helpers';

/**
 * Formats Value Data Based on ENUM Values
 * @function formatValueString
 * @param {Object} data
 * @prop {String} type - String ENUM
 * @prop {Number} value - Value to be formatted
 * @return {String}
 * @examples CURRENCY, INCOME
 */
export default data => {
  if (isFalsy(data)) return null;
  const { type, value } = data;

  switch (type) {
    case 'CURRENCY':
      return `$${value}`;
    case 'INCOME':
      return formatIncome(value);
    default:
      return `${value}`;
  }
};
